import withAemIntegration from "../../../withAemIntegration";
import {
    ResponsiveGrid,
    withComponentMappingContext,
} from "@adobe/aem-react-editable-components";
import ComponentWrapper from "../../component-wrapper";
import styled from "styled-components";
import React from "react";
import loadable from "../../../utils/loadable";
const Component = loadable(() =>
    import("@lexus.com/ui/dist/_nextgen/components/DynamicContentHotSpots")
);

const ContainerEditConfig = {
    emptyLabel: "Dynamic Content - Hot Spots",
    isEmpty: () => true,
    cqForceReload: true,
};

const Editor = styled.h3`
  text-align: center;
`;

const transformData = (props) => {
    const transformed = { ...props || {} };
    return transformed;
};

export class Container extends ResponsiveGrid {
    render() {
        const { editorMode = false } = window;
        const data = transformData(this.props);

        if (editorMode) {
            return (
                <Editor>
                    <ComponentWrapper>{super.childComponents}</ComponentWrapper>
                    {super.placeholderComponent}
                </Editor>
            );
        }
        return (
            <Component {...data} />
        );
    }
}

const DynamicContentHotSpots = withComponentMappingContext(Container);
DynamicContentHotSpots.displayName = "Dynamic Content - Hot Spots";

export default withAemIntegration(["lexus/components/content/dynamic-content/dynamic-content-hotspot"])(
    DynamicContentHotSpots,
    ContainerEditConfig
);
